<div class="row same-height">
  <div class="col-lg-6 mb-4 mb-lg-0">
    <div class="tile" data-zid="stop-loss">
      <h5 class="mb-4 font-medium">
        {{ 'tickets.stop-loss.headline' | transloco }}
      </h5>
      <div class="row mt-4 mb-4">
        <div class="col-12">
          {{ 'tickets.stop-loss.text' | transloco }}
        </div>
      </div>
      <div class="d-flex mb-4">
        <web-design-system-button
          type="secondary"
          size="small"
          href="https://support.finanzen-zero.net/hc/de/articles/18153903691165-Wie-funktioniert-eine-Trailing-Stop-Loss-Order"
        >
          {{ 'tickets.stop-loss.btn' | transloco }}
        </web-design-system-button>
      </div>
    </div>
  </div>
  <div class="col-lg-6 mb-4 mb-lg-0">
    <div class="tile d-flex flex-column justify-content-between" data-zid="faq">
      <div class="row mb-4">
        <div class="col-12">
          {{ 'tickets.faq.text' | transloco }}
        </div>
      </div>
      <div class="d-flex mb-4">
        <web-design-system-button type="secondary" size="small" href="https://support.finanzen-zero.net/">
          {{ 'tickets.faq.btn' | transloco }}
        </web-design-system-button>
      </div>
    </div>
  </div>
</div>
<div class="spacer-default hidden-xs hidden-sm hidden-md"></div>
